import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CronJobList  {
    _originalTypeClassName = "zAppDevManager.BO.CronJobList";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CronJobList.translate = translateService;
}
this.Name = null;
this.Id = null;
this.User = null;
this.VsCode = false;
this.DbGate = false;
this.Type = null;
this.Scheduled = null;
this.CronJobListKey = null;
this._key = this.CronJobListKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Id:any;
User:any;
VsCode:any;
DbGate:any;
Type:any;
Scheduled:any;
private _CronJobListKey:any;
get CronJobListKey(): any {
    return this._CronJobListKey;
  }
set CronJobListKey(value: any) {
    this._CronJobListKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CronJobListKey == null || $this.CronJobListKey == 0;
            }


}